module.exports = __webpack_public_path__ + "4633c2c624d615ec975bc9396ab31dd6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/middown-24.png
// module id = 2976
// module chunks = 0